import { getApp, initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


const firebaseConfig = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_APPID, 
  measurementId: process.env.REACT_APP_MEASUREMENTID 
};


initializeApp(firebaseConfig);

const firebaseApp = getApp();
const auth = getAuth();
const db = getFirestore();
const storage = getStorage(firebaseApp,"gs://dotoniwoof.appspot.com");
export {db, auth, storage};